import { memo } from 'react';

import { Trash2 } from 'lucide-react';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { TelegramDropTableEditAction } from './TelegramDropTableEditAction';

import css from '../TelegramDropTable.module.css';

import { telegramBotService } from 'v2/api/telegramBotService';
import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';
import { TelegramBotDropModel } from 'v2/types/TelegramBotSettingsModel';
import { handleHttpError } from 'v2/utils';

interface TelegramDropTableActionsColumnProps {
  drop: TelegramBotDropModel;
  onRevalidate: VoidFunction;
}

export const TelegramDropTableActionsColumn = memo<TelegramDropTableActionsColumnProps>(({ drop, onRevalidate }) => {
  const { trigger: triggerDelete } = useSWRMutation(
    ['deleteTelegramBotDrop', drop.id],
    telegramBotService.deleteTelegramBotDrop,
    {
      onSuccess: () => {
        onRevalidate();
      },
      onError: handleHttpError,
    }
  );

  return (
    <div className={css.telegramDropTableActions}>
      <TelegramDropTableEditAction drop={drop} onRevalidate={onRevalidate} />

      <Popconfirm message="Are you sure that you want to delete this telegram bot drop?" onConfirm={triggerDelete}>
        <Tooltip title="Delete" placement="top">
          <IconButton color="error">
            <Trash2 width={20} height={20} />
          </IconButton>
        </Tooltip>
      </Popconfirm>
    </div>
  );
});

TelegramDropTableActionsColumn.displayName = 'TelegramDropTableActionsColumn';
